import React, { useState, useContext } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import CustomAlert from "../../shared/CustemAlert";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import { MdLiveHelp } from "react-icons/md";
import MyJustDate from "../../shared/MyJustDate";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, moamad, hagsha_aharon }) {
  const { setSaeef, setShowHelp } = useContext(HelpContext);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const [newCrs, setNewCrs] = useState({
    title: "",
    length: "",
    start_date: null,
    end_date: null,
    education_frame: "",
    certifcate: "",
    moamad: moamad.id,
  });
  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const readOnly =
    moamad.signature_date ||
    MyJustDate(new Date(Date.parse(hagsha_aharon))) < MyJustDate(Date.now());

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setNewCrs((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosPrivate.post(baseURL + "course/", newCrs);
      increment();
      setShowCustomAlert(true);
    } catch (err) {
      // Handle errors
      //test
    }
  };

  return (
    <div>
      <HelpModal />
      <center>
        <div className="container">
          <div className="card text-dark bg-light p-3 border">
            {moamad.signature_date ? (
              <h4 style={{ color: "green" }}>
                המעמדות שלך למכרז נחתמה ושוגרה, לא תוכל להוסיף עדכונים.
              </h4>
            ) : (
              <h4 style={{ color: "red" }}>
                <AiOutlineWarning />
                שים לב המועמדות שלך למכרז, עדיין לא נחתמה ולא שוגרה.
                <AiOutlineWarning />
              </h4>
            )}
            <h5
              onClick={() => {
                setSaeef("4-9");
                setShowHelp(true);
              }}
            >
              קורסים והשתלמיות של המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h5>
          </div>
          {!readOnly && (
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="title" className="required-label">
                    שם הקורס/השתלמות
                  </label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    id="title"
                    value={newCrs.title}
                    onChange={handleChange}
                  />
                </div>
                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="length" className="required-label">
                        משך הקורס
                      </label>
                      <input
                        type="text"
                        name="length"
                        className="form-control"
                        id="length"
                        value={newCrs.length}
                        placeholder="כמו 3 חודשים"
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="start_date" className="required-label">
                        תקופה מ-
                      </label>
                      <input
                        type="date"
                        name="start_date"
                        className="form-control"
                        id="start_date"
                        value={newCrs.start_date}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label htmlFor="end_date" className="required-label">
                        תקופה עד-
                      </label>
                      <input
                        type="date"
                        name="end_date"
                        className="form-control"
                        id="end_date"
                        value={newCrs.end_date}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div className="form-group">
                      <label
                        htmlFor="education_frame"
                        className="required-label"
                      >
                        מסגרת לימודים
                      </label>
                      <input
                        type="text"
                        name="education_frame"
                        className="form-control"
                        id="education_frame"
                        value={newCrs.education_frame}
                        onChange={handleChange}
                      />
                    </div>
                  </Col>
                </Row>
                <div className="form-group">
                  <label htmlFor="certifcate" className="required-label">
                    תעודת גמר
                  </label>
                  <input
                    type="text"
                    name="certifcate"
                    className="form-control"
                    id="certifcate"
                    value={newCrs.certifcate}
                    onChange={handleChange}
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  הוסף
                </button>
              </form>
              {showCustomAlert && (
                <div className="alert-max-width">
                  <CustomAlert
                    setShow={setShowCustomAlert}
                    alertHeader="הוספת קורס למועמד"
                    alertBody="המקום נוסף בהצלחה"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </center>
    </div>
  );
}
